export default __webpack_public_path__ + "static/media/bingo2.48f27e33.mp3";